var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bord clear recommend",
      attrs: { id: "recommend-writer", "data-spm": "mp" },
    },
    [
      _c("div", { staticClass: "author-subscribe" }, [
        _c(
          "header",
          {
            staticClass: "header",
            attrs: { "data-spm": "author-subscribe-nav" },
          },
          [
            _c(
              "a",
              {
                staticClass: "title",
                attrs: { href: _vm.url, target: "_blank" },
              },
              [
                _vm._v(
                  "\n                " + _vm._s(_vm.title) + "\n            "
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { attrs: { "data-spm": "author-subscribe" } },
          _vm._l(_vm.data, function (item, index) {
            return _c("div", { key: index, staticClass: "container-box" }, [
              _c(
                "a",
                {
                  staticClass: "content-left",
                  attrs: { href: item.authorHomePage, target: "_blank" },
                },
                [
                  _c("img", {
                    staticClass: "avatar",
                    attrs: { src: item.authorCover },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "name" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.authorName) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "content-right",
                  attrs: { href: item.url, target: "_blank" },
                },
                [
                  _c("div", { staticClass: "article" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.title) +
                        "\n                    "
                    ),
                  ]),
                ]
              ),
            ])
          })
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }